'use client';

import { usePathname } from 'next/navigation';
import { useEffect } from 'react';

import { ROUTES, SUB_DOMAIN } from '@/constants';
import { useCustomRouter } from '@/hooks/useCustomRouter';
import { useIsNewUser } from '@/hooks/useIsNewUser';
import { useDeviceInfoStore } from '@/stores/DeviceStore';

/** 허용된 경로 */
const ALLOWED_PATHS = ['/join', '/kb-join', '/login', '/easy-certification'];

export const JoinController = () => {
  const isNewUser = useIsNewUser();

  const isKbPay = useDeviceInfoStore(
    (state) => state.subDomain === SUB_DOMAIN.KB_PAY,
  );

  const pathname = usePathname();
  const router = useCustomRouter();

  const isAllowedPath = pathname
    ? ALLOWED_PATHS.some((path) => pathname.startsWith(path))
    : true;

  // 새로운 유저이거나 허용 예외 페이지가 아닌 경우 동작
  useEffect(() => {
    if (isAllowedPath || !isNewUser) return;

    // kb인 경우 kb-join으로 이동
    if (isKbPay) {
      router.replace(
        ROUTES.KB_JOIN_COMMON.withSearchParams({ searchParams: { step: 1 } }),
      );
    } else {
      router.replace(
        ROUTES.JOIN_COMMON.withSearchParams({ searchParams: { step: 1 } }),
      );
    }
  }, [isNewUser, isAllowedPath, isKbPay, router]);

  return <></>;
};
